"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const analytics_1 = require("analytics");
const google_tag_manager_1 = require("@analytics/google-tag-manager");
const analytics = (0, analytics_1.default)({
    app: "openagent",
    plugins: [
        (0, google_tag_manager_1.default)({
            containerId: "GTM-54MR2FJ",
            id: "p316935530",
        }), //G-MQR79XWQH6
    ],
});
exports.default = analytics;
